
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import BtnRadio from "@/components/scope/btn-radio.vue";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { Table } from "@common/src/utils/decorator";
import dayjs from "dayjs";
import echarts from "echarts";
import { addCurrencyUnit } from "@common/src/utils/tools";

const finance = namespace("finance");
@Component({
  components: { BtnRadio }
})
@Table("loadListData")
export default class ReportOutputValue extends Vue {
  @finance.Action getIncomeExpenseReport;
  @finance.Action getIncomeExpenseSum;
  dayjs = dayjs;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  isactive: any = "1";
  chartFormData: any = {
    timeType: "1",
    selectedDate: []
  };
  listFormData: any = {
    statisticMethod: "1",
    beginTime: "",
    endTime: "",
    incomeExpenseType: "1"
  };
  listDataType: any = "income";
  nowDate: any = dayjs();
  tableData: any = [];
  grossProfitListData: any = [];
  created() {
    this.init();
  }
  myChart: any = {};
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(this.$refs.outputPie);
    window.addEventListener("resize", () => {
      this.myChart.resize();
    });
  }
  amountData: any = {};
  init() {
    this.chartFormData.selectedDate = [
      this.nowDate.subtract(7, "d").format("YYYYMMDD"),
      this.nowDate.subtract(1, "d").format("YYYYMMDD")
    ];
    this.listFormData.beginTime = this.nowDate.subtract(1, "d").format("YYYYMMDD");
    this.listFormData.endTime = this.listFormData.beginTime;
    this.loadChartData();
    this.loadListData();
  }
  incomeExpenseList: any = [];
  handleView(row, type) {
    let href = "";
    if (type === "1") {
      href = this.$router.resolve({
        path: `/finance/collection-order-view/${row.incomeExpenseNo}`
      }).href;
    } else {
      href = this.$router.resolve({
        path: `/finance/payment-order-view/${row.incomeExpenseNo}`
      }).href;
    }
    window.open(href, "_blank");
  }
  handleViewListDetail(type) {
    if (type === "3") {
      this.listFormData.incomeExpenseTyp = "1";
    } else {
      this.listFormData.incomeExpenseType = type;
    }
    this.isactive = type;
    this.loadListData();
  }
  draw(serverData?) {
    let showItemNum = 0;
    if (this.chartFormData.timeType === "1") {
      showItemNum = 7;
    } else if (this.chartFormData.timeType === "2") {
      showItemNum = 30;
    } else {
      showItemNum = 12;
    }
    let xData = [];
    let incomeData = [];
    let expenseData = [];
    let nowDate = this.nowDate;
    for (let i = showItemNum; i > 0; i--) {
      let tempDate = nowDate.subtract(i, "d");
      let tempDateMonth = nowDate.subtract(i, "M");
      if (this.chartFormData.timeType === "3") {
        xData.push(tempDateMonth.format("YYYY-MM"));
        let findData = serverData.data.yearTrend.find(item => item.title === tempDateMonth.format("YYYYMM"));
        if (findData) {
          incomeData.push(Number(findData.incomeAmount));
          expenseData.push(Number(findData.expenseAmount));
        } else {
          incomeData.push(0);
          expenseData.push(0);
        }
      } else {
        xData.push(tempDate.format("MM-DD"));
        let findData = serverData.data.monthTrend.find(item => item.title === tempDate.format("YYYYMMDD"));
        if (findData) {
          incomeData.push(Number(findData.incomeAmount));
          expenseData.push(Number(findData.expenseAmount));
        } else {
          incomeData.push(0);
          expenseData.push(0);
        }
      }
    }
    console.log(111, incomeData, expenseData);
    let options = {
      xAxis: {
        type: "category",
        data: xData,
        axisLabel: {
          textStyle: {
            //文字样式
            color: "#8C8C8C",
            fontSize: "12"
          },
          rotate: this.chartFormData.timeType === "2" ? 40 : 0 //倾斜度可以根据需求设置
        },
        axisLine: {
          lineStyle: {
            color: "#8C8C8C"
          }
        }
      },
      tooltip: {
        trigger: "axis",
        formatter: params => {
          console.log(params[0]);
          return `${params[0].name}<br/>${this.$t("finance.earning")}: ${splitThousands(params[0].value)}<br/>${this.$t(
            "finance.expend"
          )}: ${splitThousands(params[1].value)}`;
        }
      },
      legend: {
        data: [this.$t("finance.earning"), this.$t("finance.expend")],
        right: 10
      },
      grid: {
        x: 105,
        y: 40,
        x2: 105,
        y2: 40,
        borderWidth: 1
      },
      yAxis: {
        type: "value",
        axisLabel: {
          textStyle: {
            //文字样式
            color: "#8C8C8C",
            fontSize: "12"
          }
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        }
      },
      color: ["#2278F5", "#00B478"],
      series: [
        {
          name: this.$t("finance.earning"),
          data: incomeData,
          type: "line"
        },
        {
          name: this.$t("finance.expend"),
          data: expenseData,
          type: "line"
        }
      ]
    };
    // 绘制图表
    this.myChart.setOption(options);
  }
  grossProfitData: any = {};
  @Table.LoadDataMethod()
  loadListData() {
    let parems = Object.assign({}, this.listFormData, {
      orderItems: this.mix_sortParams,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    });
    return this.getIncomeExpenseSum(parems).then(data => {
      this.amountData = data.data;
      this.incomeExpenseList = data.data.list;
      return data;
    });
  }
  handleTableDateTypeChange(val) {
    if (val === "1") {
      this.listFormData.beginTime = this.nowDate.subtract(1, "d").format("YYYYMMDD");
      this.listFormData.endTime = this.nowDate.subtract(1, "d").format("YYYYMMDD");
    } else {
      this.listFormData.beginTime = this.nowDate.subtract(1, "M").format("YYYYMM");
      this.listFormData.endTime = this.nowDate.subtract(1, "M").format("YYYYMM");
    }
    this.loadListData();
  }
  handleListDateChange() {
    this.loadListData();
  }
  loadChartData() {
    let statisticMethod = "";
    if (this.chartFormData.timeType === "3") {
      statisticMethod = "2";
    } else {
      statisticMethod = "1";
    }
    this.getIncomeExpenseReport({
      statisticMethod,
      beginTime: this.chartFormData.selectedDate[0],
      endTime: this.chartFormData.selectedDate[1]
    }).then(data => {
      console.log(data);
      this.draw(data);
    });
  }
  handleDateChange(val) {
    switch (val) {
      case "1":
        this.chartFormData.selectedDate = [
          this.nowDate.subtract(7, "d").format("YYYYMMDD"),
          this.nowDate.subtract(1, "d").format("YYYYMMDD")
        ];
        break;
      case "2":
        this.chartFormData.selectedDate = [
          this.nowDate.subtract(30, "d").format("YYYYMMDD"),
          this.nowDate.subtract(1, "d").format("YYYYMMDD")
        ];
        break;
      default:
        this.chartFormData.selectedDate = [
          this.nowDate.subtract(365, "d").format("YYYYMM"),
          this.nowDate.subtract(1, "d").format("YYYYMM")
        ];
    }
    this.loadChartData();
  }
}
